import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { BreadcrumbsService } from '../../../../shared/breadcrumbs/breadcrumbs.service';
import { ActivatedRoute, ActivationStart, Router } from '@angular/router';
import { get } from 'lodash';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { Microsoft360ViewContext } from '../../../../shared/contexts/microsoft-360-view.context';
import { MicrosoftTileConfigContext } from '../../../shared/contexts/microsoft-tile-config.context';
import { UsageLocationContext } from '../../../../shared/contexts/usage-location.context';

@Component({
  selector: 'ziro-microsoft-360-detail',
  templateUrl: './microsoft360-detail.component.html',
  styleUrls: ['./microsoft360-detail.component.scss'],
  providers: [Microsoft360ViewContext, MicrosoftTileConfigContext, UsageLocationContext],
  standalone: false,
})
export class Microsoft360DetailComponent implements OnInit, OnDestroy {
  private breadcrumbsService = inject(BreadcrumbsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  baseCrumb: MenuItem;
  isPageLoading = true;
  upn: string;
  isAutoAttendantEditFormActive = signal(false);

  private _subs = new Subscription();

  ngOnInit(): void {
    this.upn = this.route.snapshot.paramMap.get('upn');

    const tenantId = this.route.snapshot.paramMap.get('tenantId');
    this.baseCrumb = {
      label: 'tkey;microsoft_360.view.breadcrumb.home.text',
      url: `/helpdesk/tenants/${tenantId}/360-view/${this.upn}`,
      routerLink: true,
    };

    this._updateBreadcrumb(
      this.route.firstChild.snapshot.data.breadcrumb,
      this.route.firstChild.snapshot.data.is360ViewChild,
    );
    const sub = this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        const activeRouteCrumb = get(event, ['snapshot', 'data', 'breadcrumb']);
        const is360ViewChild = get(event, ['snapshot', 'data', 'is360ViewChild']);
        this._updateBreadcrumb(activeRouteCrumb, is360ViewChild);
        this.isAutoAttendantEditFormActive.set(!!event.snapshot.params['autoAttendantId']);
      }
    });
    this._subs.add(sub);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private _updateBreadcrumb(crumb: string, is360ViewChild: boolean): void {
    if (crumb !== this.baseCrumb.label && is360ViewChild) {
      this.breadcrumbsService.updateBreadcrumbs([this.baseCrumb, { label: crumb }, { label: '' }]);
    } else if (crumb !== this.baseCrumb.label) {
      this.breadcrumbsService.updateBreadcrumbs([this.baseCrumb, { label: crumb }]);
    } else {
      this.breadcrumbsService.updateBreadcrumbs([this.baseCrumb]);
    }
  }

  setLoading(event: boolean): void {
    this.isPageLoading = !event;
  }
}
